import ajax from '../http/ajax'

/**
 * 获取分销活动信息
 * @param {*} params 参数
 * @return 略
 */
export const getDistributionActivityInfo = params => {
    return ajax.get('getDistributionActivityInfo', params)
}

/**
 * 获取分销活动商品信息
 * @param {*} params 参数
 * @return 略
 */
export const getDistributionActivityGoodsList = params => {
    return ajax.post('getDistributionActivityGoodsList', params)
}
